/* eslint-disable no-unused-vars */
import ApiService from "../api.service";
import appConfig from "../../../app-config";
import SalesFormulas from "../../../_helpers/formulas/sales-formulas";

import { getFactorByCode } from "../../../_store/helpers";

const controller = new AbortController();
const signal = controller.signal;

const {
  calculateStockUMQty,
  calculateDiscLineTotal,
  calculateNetLineTotal,
  calculateWetLineTotal,
  calculateTaxableLineTotal,
  calculateTaxLineTotal,
  calculateLineTotal,
  calculateDiscFXLineTotal,
  calculateNetFXLineTotal,
  calculateWetFXLineTotal,
  calculateTaxableFXLineTotal,
  calculateTaxFXLineTotal,
  calculateFXLineTotal,
} = SalesFormulas;

ApiService.init(appConfig.VUE_APP_ROOT_API);

const SalesOrderV3Service = {
  async getSaleItemPrice(params, signal) {
    var url = "api/SaleItemPrice?TransactionDate={TransactionDate}&SalesOrderTypeCode={SalesOrderTypeCode}&ItemType={ItemType}&BranchCode={BranchCode}&CustomerCode={CustomerCode}&ItemCode={ItemCode}&SalesUM={SalesUM}&SalesUMQty={SalesUMQty}&ExchangeRate={ExchangeRate}"
      .replace("{TransactionDate}", params.TransactionDate)
      .replace("{SalesOrderTypeCode}", params.SalesOrderTypeCode)
      .replace("{ItemType}", params.ItemType)
      .replace("{BranchCode}", params.BranchCode)
      .replace("{CustomerCode}", params.CustomerCode)
      .replace("{ItemCode}", params.ItemCode)
      .replace("{SalesUM}", params.SalesUM)
      .replace("{SalesUMQty}", params.SalesUMQty)
      .replace("{ExchangeRate}", params.ExchangeRate);
    return await ApiService.get(url, signal);
  },

  async setSaleItemPrice(
    newData,
    currentRowData,
    soTypeCode,
    branchCode,
    customerCode,
    exchangeRate,
    dateIn,
    reqdByDate,
    calculateComputedFields
  ) {
    var tranDate = dateIn; // window.ViewModel.Screen.DateIn();

    let requiredByFactor = getFactorByCode(616);
    // eslint-disable-next-line no-console
    // this.$logger.debug("requiredByFactor", requiredByFactor);
    if (
      requiredByFactor &&
      requiredByFactor.Factorc.toUpperCase() === "REQUIRED BY"
    ) {
      tranDate = reqdByDate;
    }

    if (tranDate) tranDate = new Date(tranDate).toShortDateString();

    var itemCode = currentRowData.ItemCode;
    if (currentRowData.OriginItemCode)
      itemCode = currentRowData.OriginItemCode;

    var requestData = {
      TransactionDate: tranDate,
      SalesOrderTypeCode: soTypeCode,
      BranchCode: branchCode,
      CustomerCode: customerCode,
      ExchangeRate: exchangeRate,
      ItemType: currentRowData.ItemType,
      ItemCode: itemCode,
      SalesUM: currentRowData.SalesUM,
      SalesUMQty: currentRowData.SalesUMQty,
    }; 

    // eslint-disable-next-line no-console
    // this.$logger.debug("getSaleItemPrice REQUEST: " + JSON.stringify(requestData));
    // window.ViewModel.CommonHelper.logMessage(
    //   "getSaleItemPrice REQUEST: " + JSON.stringify(requestData)
    // );

    return await this.getSaleItemPrice(requestData, currentRowData.ID ? currentRowData.ID : itemCode)
      .then((res) => {
        let data = res.data;
        // eslint-disable-next-line no-console
        // this.$logger.debug("getSaleItemPrice RESPONSE: " + JSON.stringify(data));
        // window.ViewModel.CommonHelper.logMessage(
        //   "getSaleItemPrice RESPONSE: " + JSON.stringify(data)
        // );

        newData.AddDiscPriceGroupCode = data.AddDiscPriceGroupCode || 0;
        newData.AddDiscPricingMethod = data.AddDiscPricingMethod || "";
        newData.AddDiscPricingMethodValue = data.AddDiscPricingMethodValue || 0;
        newData.AddDiscSalesUMPrice = data.AddDiscSalesUMPrice;
        newData.AddDiscStockUMPrice = data.AddDiscStockUMPrice;
        newData.CalculatedDiscPcnt = data.CalculatedDiscPcnt;
        newData.DiscPcnt = data.DiscPcnt;
        newData.IsPrimeCostItem = data.IsPrimeCostItem;
        newData.PriceGroupCode = data.PriceGroupCode || data.AddDiscPriceGroupCode;
        newData.PriceGroupSalesUMPrice = data.PriceGroupSalesUMPrice;
        newData.PriceGroupStockUMPrice = data.PriceGroupStockUMPrice;
        newData.PricingMethod = data.PricingMethod;
        newData.PricingMethodValue = data.PricingMethodValue || 0;
        newData.SalesTaxPcnt = data.SalesTaxPcnt;
        newData.SalesUMConversion = data.SalesUMConversion;
        newData.SalesUMCost = data.SalesUMStandardCost;
        newData.StockUMStandardCost = data.StockUMStandardCost;
        newData.ExTaxUnitCost = data.StockUMStandardCost;
        newData.SalesUMFXPrice = data.SalesUMFXPrice;
        newData.SalesUMIsVariable = data.SalesUMIsVariable;
        newData.SalesUMManufacturedCost = (
          data.StockUMStandardCost * data.SalesUMConversion
        ).roundNumber(4);
        newData.SalesUMQty !== 0
          ? (newData.SalesUMNetFXPrice = data.SalesUMNetFXPrice)
          : (newData.SalesUMNetFXPrice = 0);
        newData.SalesUMNetPrice = data.SalesUMNetPrice;
        newData.SalesUMPrice = data.SalesUMPrice;
        newData.SalesUMPromotionNetPrice = data.SalesUMPromotionNetPrice;
        newData.SalesUMStandardCost = data.SalesUMStandardCost;
        newData.SalesUMStandardPrice = data.SalesUMStandardPrice;
        newData.StockUM = data.StockUM;
        newData.StockUM = data.StockUM;
        newData.StockUMFXPrice = data.StockUMFXPrice;
        newData.StockUMManufacturedCost = data.StockUMStandardCost;
        newData.StockUMNetFXPrice = data.StockUMNetFXPrice;
        newData.StockUMNetPrice = data.StockUMNetPrice;
        newData.StockUMPrice = data.StockUMPrice;
        newData.StockUMQty = calculateStockUMQty(
          newData.SalesUMQty,
          newData.SalesUMConversion
        );
        newData.StockUMStandardPrice = data.StockUMStandardPrice;
        newData.TaxCode = data.TaxCode;
        newData.WetPcnt = data.WetPcnt;

        // FX Totals
        newData.DiscFXLineTotal = calculateDiscFXLineTotal(
          newData.SalesUMFXPrice,
          newData.SalesUMNetFXPrice,
          newData.SalesUMQty
        );
        newData.NetFXLineTotal = calculateNetFXLineTotal(
          newData.SalesUMNetFXPrice,
          newData.SalesUMQty
        );

        newData.WetFXLineTotal = calculateWetFXLineTotal(
          newData.NetFXLineTotal,
          newData.WetPcnt
        );

        newData.TaxableFXLineTotal = calculateTaxableFXLineTotal(
          newData.NetFXLineTotal,
          newData.WetFXLineTotal
        );
        newData.TaxFXLineTotal = calculateTaxFXLineTotal(
          newData.NetFXLineTotal,
          newData.WetFXLineTotal,
          newData.SalesTaxPcnt
        );
        newData.FXLineTotal = calculateFXLineTotal(
          newData.TaxableFXLineTotal,
          newData.TaxFXLineTotal
        );

        // Totals
        newData.DiscLineTotal = calculateDiscLineTotal(
          newData.DiscFXLineTotal,
          exchangeRate
        );
        newData.NetLineTotal = calculateNetLineTotal(
          newData.NetFXLineTotal,
          exchangeRate
        );
        newData.WetLineTotal = calculateWetLineTotal(
          newData.WetFXLineTotal,
          exchangeRate
        );
        newData.TaxableLineTotal = calculateTaxableLineTotal(
          newData.TaxableFXLineTotal,
          exchangeRate
        );
        newData.TaxLineTotal = calculateTaxLineTotal(
          newData.TaxFXLineTotal,
          exchangeRate
        );
        newData.LineTotal = calculateLineTotal(
          newData.FXLineTotal,
          exchangeRate
        );

        // if (calculateComputedFields) {
        //   window.ViewModel.calculateComputedFields();
        // }

        // record.refreshTemplateForColumn("ItemCode");

        return newData;
      })
      .catch((error) => {
        // eslint-disable-next-line no-console
        // this.$logger.debug("setSalesItemPrice ERROR", error);
        // if (calculateComputedFields) {
        //   window.ViewModel.calculateComputedFields();
        // }

        return error;
      });
  },

  async saveSalesOrder(payload, orderId) {
    var url = `api/Save_SalesOrderV2`;

    // if (orderId > 0) {
    //   return await ApiService.put(url, orderId, payload, "Integer");
    // } else {
    return await ApiService.post(url, payload);
    // }
  },

  async getSalesOrderDetailsByCode(code, params) {
    const requestScreenData = {
      url: "api/SalesOrderDetailCompanyBranch",
      filter: `SalesOrderCode eq ${code}`,
    };

    if (params) {
      if (params.select) {
        requestScreenData.select = params.select;
      }
    }

    return await ApiService.oDataGet(requestScreenData);
  },

  async getSaleItemCompanyBranchProduct(branchCode) {
    const requestData = {
      url: "api/SaleItemCompanyBranch",
      filter: `ItemType eq 'S' and BranchCode eq '${branchCode}' and AvailableForSale eq 'Y'`,
      select: ["SalesUM", "ItemType", "ItemCode", "BranchCode"],
    };
    return await ApiService.oDataGet(requestData);
  },
};

export { SalesOrderV3Service };
